import { useQuery } from "@tanstack/react-query";
import { getReportsAnalyticsFinancial } from "../../API/ProtectedAuth";
import { handleApiError } from "../../Utils/errorHandler";

export default function useFinancial(options = {}) {
  const {
    period = "30d",
    detailed = true,
    include_charts = true,
  } = options;

  const queryKey = ["financialReports", { period, detailed, include_charts }];

  const {
    data,
    error,
    isLoading,
    refetch,
  } = useQuery({
    queryKey,
    queryFn: async () => {
      try {
        const res = await getReportsAnalyticsFinancial({
          period,
          detailed,
          include_charts,
        });
        return res;
      } catch (err) {
        handleApiError(err);
        throw err;
      }
    },
    staleTime: 1000 * 60 * 30, 
    cacheTime: 1000 * 60 * 60 * 12,
    refetchOnWindowFocus: false,
  });

  const financial = data?.data ?? null;
  const generatedAt = data?.meta?.generated_at ? new Date(data.meta.generated_at) : null;

  return {
    financial,
    generatedAt,
    error,
    isLoading,
    reload: refetch,
    period,
  };
}






































































